import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
} from "@mui/material";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

const EditStudentProfile = () => {
  const user = useSelectAccess("Student");
  const navigate = useNavigate();

  const [formError, setFormError] = useState(null);

  const formik = useFormik({
    initialValues: {
      name: "",
      contactno: "",
      email: "",
      college_name: "",
      current_address: "",
      permanent_address: "",
      occupation: "",
      gender: "",
      village: "",
      district: "",
      taluka: "",
      state: "",
    },

    validationSchema: yup.object({
      name: yup.string().required("Enter your Full Name"),
      contactno: yup
        .string()
        .matches(/^\d{10}$/, "Enter a valid 10-digit contact number")
        .required("Enter your Contact Number"),
      email: yup
        .string()
        .email("Enter a valid email")
        .required("Enter your email"),
      college_name: yup.string().required("Enter your college name"),
      occupation: yup.string().required("Enter your Occupation"),
      current_address: yup.string().required("Enter your Current Address"),
      permanent_address: yup.string().required("Enter your Permanant Address"),
      gender: yup.string().required("Enter your Gender"),
      village: yup.string().required("Enter your vilage name"),
      district: yup.string().required("Enter your district Name"),
      taluka: yup.string().required("Enter your taluka name"),
      state: yup.string().required("Enter your state name"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        const response = await server.put("/register/updatestudent", values, {
          headers: {
            Authorization: user.authToken,
          },
        });
        toast.success("Profile updated successfully");
        navigate("/studentprofile");
      } catch (error) {
        if (error instanceof AxiosError && error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error("Failed to update profile");
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    // Fetch user data when the component mounts
    const fetchData = async () => {
      try {
        const response = await server.get("/register/studentprofile", {
          headers: {
            Authorization: user.authToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        // Populate the form with user data
        formik.setValues(response.data);
      } catch (error) {
        if (error.response?.status === 401) {
          navigate("/loginstudent");
        }
        console.error("Error fetching user data:", error);
      }
    };

    if (!formik.values.name) {
      fetchData();
    }
  }, [formik.values.name, navigate, user.authToken, formik.setValues]);

  return (
    <div>
      <div className="container mb-5">
        <div className="row">
          <div className="col">
            <form
              className="needs-validation d-flex flex-column gap-3"
              onSubmit={formik.handleSubmit}
            >
              <div className="card">
                <h5 className="p-3 fs-5 data-name  mb-0">Personal Details</h5>
                <div className="row px-5">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="name"
                        type="text"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        placeholder="Lorem"
                        variant="outlined"
                        label="Full Name"
                        fullWidth
                        required
                      ></TextField>
                    </div>

                    <div className="col-md-6 mb-3">
                      <TextField
                        name="contactno"
                        type="number"
                        value={formik.values.contactno}
                        onChange={formik.handleChange}
                        placeholder="9876789087"
                        variant="outlined"
                        label="Contact Number"
                        disabled
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="email"
                        type="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        placeholder="loremipsum@gmail.com"
                        variant="outlined"
                        label="Email"
                        disabled
                        fullWidth
                        required
                      ></TextField>
                    </div>

                    <div className="col-md-6 mb-3">
                      <TextField
                        name="college_name"
                        type="text"
                        value={formik.values.college_name}
                        onChange={formik.handleChange}
                        placeholder="Enter College Name"
                        variant="outlined"
                        label="College Name"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="current_address"
                        type="text"
                        value={formik.values.current_address}
                        onChange={formik.handleChange}
                        variant="outlined"
                        label="current_address"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="permanent_address"
                        type="text"
                        value={formik.values.permanent_address}
                        onChange={formik.handleChange}
                        variant="outlined"
                        label="Permanent Address"
                        fullWidth
                        required
                      ></TextField>
                    </div>{" "}
                    <div className="col-md-6 mb-3">
                      <FormControl fullWidth required className="mb-2">
                        <InputLabel id="demo-simple-select-label">
                          Occupation
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Occupation"
                          variant="outlined"
                          name="occupation"
                          value={formik.values.occupation}
                          onChange={formik.handleChange}
                          required
                        >
                          <MenuItem value="Student">Student</MenuItem>
                          <MenuItem value="Gov Employee">Gov Employee</MenuItem>
                          <MenuItem value="Retired">Retired</MenuItem>
                          <MenuItem value="Private Emp">Private Emp</MenuItem>
                          <MenuItem value="Unemployed">Unemployed</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6 mb-3">
                      <FormControl fullWidth required className="mb-2">
                        <InputLabel id="demo-simple-select-label">
                          Gender
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Gender"
                          variant="outlined"
                          name="gender"
                          value={formik.values.gender}
                          onChange={formik.handleChange}
                          required
                        >
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="village"
                        type="text"
                        value={formik.values.village}
                        onChange={formik.handleChange}
                        placeholder="Village"
                        variant="outlined"
                        label="Village"
                        fullWidth
                        required
                      ></TextField>
                    </div>

                    <div className="col-md-6 mb-3">
                      <TextField
                        name="district"
                        type="text"
                        value={formik.values.district}
                        onChange={formik.handleChange}
                        placeholder="District"
                        variant="outlined"
                        label="District"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="taluka"
                        type="text"
                        value={formik.values.taluka}
                        onChange={formik.handleChange}
                        placeholder="Taluka"
                        variant="outlined"
                        label="Taluka"
                        fullWidth
                        required
                      ></TextField>
                    </div>

                    <div className="col-md-6 mb-3">
                      <TextField
                        name="state"
                        type="text"
                        value={formik.values.state}
                        onChange={formik.handleChange}
                        placeholder="State"
                        variant="outlined"
                        label="State"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <button
                type="submit"
                className="banner p-2 text-white rounded-3 border-0"
              >
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditStudentProfile;
